import React from 'react';
import styled, {keyframes} from 'styled-components';
import { FaTrash } from 'react-icons/fa';
import Tag from './Tag';

class TaskListItem extends React.Component {

    constructor(props) {
        super(props);
        const anim_fade_down = keyframes`
            0% {
                opacity: 0;
                transform: translateY(-5px);
            }
            100% {
                opacity: 1;
                transform: translateY(0px);
            }
        `;
        this.container = styled.li `
            background-color: #fff;
            display: ${props => props.small ? 'inline-block' : 'block'};
            margin: ${props => props.small ? '0 8px 8px 0' : '0'};
            border-radius: ${props => props.small ? '4px' : 'unset'};
            width: ${props => props.small ? '160px' : 'initial'};
            .task_info_block{
                width: ${props =>  props.renderOption ? props.small ? '70%' : '80%' : '100%'};
                padding: ${props => props.small ? '8px 16px' : '14px 20px'};
                position: relative;
                &:HOVER{
                    .task_description_hover{
                        display: inline-block;
                        animation: ${anim_fade_down} 0.5s 0.2s both;
                        z-index: 5;
                    }
                }
                .task_description_hover{
                    pointer-events: none;
                    display: none;
                    position: absolute;
                    left: 14px;
                    top: 32px;
                    background-color: #000;
                    color: #fff;
                    padding: 6px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    line-height: 18px;
                }
            }
            .task_remove_block{
                cursor: pointer;
                padding: 0 12px;
                border-left: 1px solid ${props => props.theme.colors.border};
                width: 20%;
                text-align: center;
                opacity: 0.6;
                &:HOVER{
                    opacity: 1;
                }
            }

            .task_info_block, .task_remove_block{
                display: inline-block;
                vertical-align: middle;
            }

            .task_title{
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 4px;
            }
            .task_description{
                white-space: nowrap;
                font-size: 12px;
                line-height: 16px;
                opacity: 0.5;
                overflow: hidden;
            }
            .task_tags{
                padding: 2px 0 2px 0;
            }
        `;
    }

    renderTrash() {
        if (!this.props.onClickRemove) {
            return null;
        }

        return (
            <div
                className="task_remove_block"
                onClick={() => {
                    this.props.onClickRemove();
                }}
                >
                <FaTrash />
            </div>
        );
    }

    render() {

        return (
            <this.container small={this.props.small} className="task_list_item" renderOption={this.props.onClickRemove}>
                <div
                    className="task_info_block"
                    onClick={() => {
                           this.props.onClickItem();
                       }}>
                    <p className="task_title">
                        {this.props.task.type}
                    </p>
                    <p className="task_description">
                        {this.props.task.data.description}
                    </p>
                    <div className="task_description_hover">
                        <div className="task_tags">
                            {
                                this.props.task.tags.map((tag, i) => {
                                    return (<Tag small key={i} label={tag ? tag.name : 'undefined'}/>);
                                 })
                            }
                        </div>
                        {this.props.task.data.description}
                    </div>
                </div>
                { this.renderTrash() }
            </this.container>
        );
    }
}

export default TaskListItem;



// WEBPACK FOOTER //
// ./src/components/base/TaskListItem.jsx